import { dropBoolean } from 'utils/drops';

const getCcustoFilterFields = () => [
  { name: 'id', label: 'ID', type: 'number' },
  { name: 'descricao', label: 'Descrição', initial: true },
  { name: 'codigo', label: 'Código' },
  { name: 'terceiro', label: 'Terceiro', type: 'select', options: dropBoolean },
  { name: 'ativo', label: 'Ativo', type: 'select', options: dropBoolean },
];

export default getCcustoFilterFields;
